module.exports = __webpack_public_path__ + "static/media/sketches.363bbace.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/sketches.mov
// module id = 424
// module chunks = 0